module.exports = __webpack_public_path__ + "img/log-all.497ec2cd.svg";